import _ from 'lodash';
import {
  WHEEL_POSITIONS,
  WHEEL_PHOTO_PART,
  WHEEL_LOCATION_PHOTO_KEYS,
  WHEEL_LOCATION_PHOTO_LABELS,
  locationPhotoPart,
  prePhotoPart,
} from '../../constants/WheelInspectionConstants';
import { getPositionLabel } from '../../utils/wheelInspectionUtil';

export const PRE_GRID_SLOT_COUNT = 6;
export const POST_GROUPS_PER_PAGE = 2;

export const buildPrePhotoSlots = (inspection, findSrc) => {
  const slots = [];
  const insurance = _.get(inspection, 'preRestoration.insuranceHandled', []);
  if ((Array.isArray(insurance) ? insurance : [insurance]).includes('Y')) {
    const partCode = WHEEL_PHOTO_PART.PRE_PLATE;
    slots.push({
      partCode,
      label: '차량번호',
      src: findSrc(partCode),
    });
  }

  const positions = _.get(inspection, 'preRestoration.positions', []);
  positions.forEach((pos) => {
    const partCode = prePhotoPart(pos);
    slots.push({
      partCode,
      label: getPositionLabel(pos),
      src: findSrc(partCode),
    });
  });

  return slots;
};

/** §4 — 3×2 고정 그리드용 빈 칸 채우기 */
export const padPrePhotoSlotsForGrid = (
  slots,
  total = PRE_GRID_SLOT_COUNT
) => {
  const padded = [...slots];
  for (let i = padded.length; i < total; i += 1) {
    padded.push({
      partCode: `pre_grid_empty_${i}`,
      label: '',
      src: null,
      isPlaceholder: true,
    });
  }
  return padded.slice(0, total);
};

export const buildPostPhotoGroups = (inspection, findSrc) => {
  const positions = _.get(inspection, 'preRestoration.positions', []);
  return WHEEL_POSITIONS.filter((p) => positions.includes(p.code)).map((p) => ({
    key: p.code,
    title: `${getPositionLabel(p.code)} (복원후)`,
    slots: WHEEL_LOCATION_PHOTO_KEYS.map((key) => {
      const partCode = locationPhotoPart(p.code, key);
      return {
        partCode,
        label: WHEEL_LOCATION_PHOTO_LABELS[key],
        src: findSrc(partCode),
      };
    }),
  }));
};

export const paginateGroups = (groups, perPage) => {
  if (!groups.length) return [];
  const pages = [];
  for (let i = 0; i < groups.length; i += perPage) {
    pages.push(groups.slice(i, i + perPage));
  }
  return pages;
};
